import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';
import { CommonButtonTypes } from 'Common/Types/Types';

export const useStyles = makeStyles<Theme, CommonButtonTypes>((theme: Theme) => {
	return createStyles({
		root: {
			display: 'flex',
			flexWrap: 'wrap',
			minWidth: 300,
			width: '100%',
		},
		goBack: {
			cursor: 'pointer',
			'&:hover': {
				opacity: 0.5,
			},
		},
		iconHolder: {
			background: ({ common }) => `${common?.background ? common?.background : 'white'}`,
			borderRadius: ({ common }) => `${common?.radius ? common?.radius : '5px'}`,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			width: '66.5px',
			height: '62.69px',
		},
		conditional: {
			borderRadius: '2rem',
			color: 'white',
			fontSize: '14px',
			fontWeight: 100,
			background: ({ condition }) => `${condition === 'yes' || condition === 'Confirm' ? '#77c731' : condition === 'no' ? '#FF7552' : '#7FD6DD'}`,
		},
		commonButton: {
			borderRadius: ({ common }) => `${common?.radius ? common?.radius : 'inherit'}`,
			backgroundColor: ({ common }) => `${common?.background ? common.background : 'inherit'}`,
			margin: ({ common }) => `${common?.margin ? common.margin : '1rem 0'}`,
			width: ({ common }) => `${common?.width ? common?.width : 'inherit'}`,
			height: ({ common }) => `${common?.height ? common?.height : 'inherit'}`,
			textTransform: ({ common }) => (common?.textTransform ? common?.textTransform : 'initial'),
			fontSize: ({ common }) => (common?.fontSize ? common?.fontSize : '24px'),
			color: ({ common }) => (common?.color ? common?.color : 'white'),
			fontWeight: ({ common }) => (common?.fontWeight ? common?.fontWeight : '100'),
			lineHeight: ({ addLineHeight }) => (addLineHeight && 'normal' ),
			boxShadow: 'none',
			'&:hover': {
				backgroundColor: ({ common }) => `${common?.background ? common.background : 'white !important'}` 
			},
			[theme.breakpoints.down('xs')]: {
				fontSize: ({ common }) => (common?.fontSize ? common?.fontSize : '16px'),
				width: ({ isAuthButton }) => (isAuthButton ? '300px !important' : '')  
				// '300px !important'
			},
		},
	});
});
